<script setup>
import { useMenuLateralStore } from "@/stores/menuLateral";
import Button from "primevue/button";

const props = defineProps({
    severity: {
        type: String,
        default: 'primary'
    },
    title: {
        type: String,
        default: 'Menu'
    },
    size: {
        type: String,
        default: 'large'
    },
    rounded: {
        type: Boolean,
        default: false
    },
    outlined: {
        type: Boolean,
        default: false
    },
    text: {
        type: Boolean,
        default: false
    },
    buttonClass: {
        type: [String, Array, Object]
    },
    iconClass: {
        type: [String, Array, Object]
    },
    buttonStyle: {
        type: Object,
        default: () => ({})
    },
    iconStyle: {
        type: Object,
        default: () => ({})
    }
});

const menuLateral = useMenuLateralStore();
</script>

<template>
    <Button
        :title="props.title"
        icon="pi pi-bars"
        :severity="props.severity"
        :size="props.size"
        :rounded="props.rounded"
        :outlined="props.outlined"
        :text="props.text"

        :pt:root:class="['button', props.buttonClass]"
        :pt:root:style="props.buttonStyle"

        :pt:icon:class="props.iconClass"
        :pt:icon:style="props.iconStyle"

        @click="menuLateral.openMenu()"
    />
</template>

<style scoped>
.button {
    //min-width: 49px;
}
</style>
